/**
 * @ignore
 */
export const environment = {
	production: true,
	name: 'prod',
	fileCacheKey: '654654561988',
	nfcReaderUrl: 'ws://cockpit.jdc-airports.com:8088'
};